<template lang="pug">
  .component-credit-records
    .component-credit-record(v-if="$is('listing')")
      .inner-content
        .component-card
          .row
            .column.expanded
              h3.mb-0 CR{{item.id}}
               small(v-if="item.service" ) &nbsp;{{item.service}} only

              .field-value {{item.status}}
              small
                span {{item.type}}
                span(v-if="item.type === 'USE'") &nbsp; {{item.walletable_type?item.walletable_type:'--'}} {{item.walletable_id?item.walletable_id:'--'}}
              .description(slot="bottom") {{item.reason.replace('|',' - ')}}
            .column.shrink
              .fiel-content
                .label Created
                .field-value {{$dateFormat(item.created_at, $toMomentFormat(configuration.locale.locale_date_format.value))}}

            .column.shrink.pl-0
              dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'bottom'")
                CreditRecordButtons(:item="item", @itemUpdated="$emit('itemUpdated')")
          .row.text-center.pt-0
            .column
              .label Valid From
              .field-value(v-if="item.valid_from") {{$dateFormat(item.valid_from, $toMomentFormat(configuration.locale.locale_date_format.value))}}
              .field-value(v-else) --
            .column
              .label Valid To
              .field-value(v-if="item.valid_to") {{$dateFormat(item.valid_to, $toMomentFormat(configuration.locale.locale_date_format.value))}}
              .field-value(v-else) --
            .column
              .label Amount

              h3.mb-0 {{$priceWithcurrency(item.amount)}}

    .component-credit-record(v-if="$is('usages')")
      .inner-content
        .component-card
          .row
            .column
              label CR{{item.id}}
              .field-value {{item.status}}
              small
                span {{item.type}}
                span(v-if="item.type === 'USE'") &nbsp; {{item.walletable_type?item.walletable_type:'--'}} {{item.walletable_id?item.walletable_id:'--'}}


            .column
              .label Amount
              h3.mb-0 {{$priceWithcurrency(item.amount)}}
            .column
              label Reason
              .field-value {{item.reason}}
            .column
              .fiel-content
                .label Created
                .field-value {{item.created_at}}
            //.column.shrink.pl-0
              dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'bottom'")
                CreditRecordButtons(:item="item", @itemUpdated="$emit('itemUpdated')")


</template>

<script>
  import CardN from '../structure/CardN'
  import {mapState} from 'vuex'
  import ActionButton from '../structure/ui/ActionButton'
  import CreditRecordButtons from '../structure/ui/actions/CreditRecordButtons'
  import Dropdown from '../structure/foundation/Dropdown'

  export default {
    name: 'CreditRecord',
    components: {Dropdown, CreditRecordButtons, ActionButton, CardN},
    computed: {
      ...mapState({
        configuration: state => state.configuration,
      }),
    },
    props: ['item', 'type']
  }
</script>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// CreditRecord.vue?e57d0ebe